import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SOLUTIONS } from '../../../../core/constants/solutions';
import { CommonModule } from '@angular/common';
import { ISolution } from '../../../../core/models/solution.model';

@Component({
  selector: 'app-solutions-list',
  templateUrl: './solutions-list.component.html',
  styleUrls: ['./solutions-list.component.scss'],
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class SolutionsListComponent implements OnInit {
  solutions = SOLUTIONS;
  isResponsive: boolean = false;
  @Input() currentId?: number;
  @Output() selectSolutionEvent = new EventEmitter<ISolution>();

  constructor() { }

  ngOnInit() {
  }

  selectSolution(item: ISolution) {
    this.selectSolutionEvent.emit(item);
  }

}
